module.exports = __webpack_public_path__ + "img/AlertClosingIcon.4b19d9c8.svg";